import axios from 'axios';

const API_BASE = '/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const getProfiles = async () => {
  const response = await api.get('/profiles');
  return response.data;
};

export const getAdminProfiles = async () => {
  const response = await api.get('/admin/profiles');
  return response.data;
};

export const updateProfile = async (profile) => {
  // Use the simpler endpoint that doesn't require admin session
  const response = await api.post('/profile-products', {
    id: profile.id,
    produkte: profile.produkte,
    sortierung: profile.sortierung
  });
  return response.data;
};

export const addProfile = async (profile) => {
  const response = await api.post('/admin/profiles', profile);
  return response.data;
};

export const deleteProfile = async (id) => {
  const response = await api.delete('/admin/profiles', { data: { id } });
  return response.data;
};

export const getProducts = async (profile = null) => {
  const params = profile ? `?profile=${profile}` : '';
  const response = await api.get(`/products${params}`);
  return response.data;
};

export const createOrder = async (orderData) => {
  const response = await api.post('/orders', orderData);
  return response.data;
};

export const adminLogin = async (password) => {
  const response = await api.post('/admin/login', { pw: password });
  return response.data;
};

export const adminLogout = async () => {
  const response = await api.post('/admin/logout');
  return response.data;
};

export const getAdminProducts = async () => {
  const response = await api.get('/admin/products');
  return response.data;
};

export const addProduct = async (product) => {
  const response = await api.post('/admin/products', product);
  return response.data;
};

export const updateProduct = async (product) => {
  const response = await api.put('/admin/products', product);
  return response.data;
};

export const cloneProduct = async (id) => {
  const response = await api.post('/admin/products', { clone_id: id });
  return response.data;
};

export const deleteProduct = async (id) => {
  const response = await api.delete('/admin/products', { data: { id } });
  return response.data;
};

export const getAdminOrders = async () => {
  const response = await api.get('/admin/orders');
  return response.data;
};

export const getPrinters = async () => {
  const response = await api.get('/printers');
  return response.data;
};

export const getAdminPrinters = async () => {
  const response = await api.get('/admin/printers');
  return response.data;
};

export const updatePrinter = async (printerId, name) => {
  const response = await api.put(`/admin/printers/${printerId}`, { name });
  return response.data;
};

export const getPrintSettings = async () => {
  const response = await api.get('/admin/print-settings');
  return response.data;
};

export const savePrintSettings = async (settings) => {
  const response = await api.post('/admin/print-settings', settings);
  return response.data;
};

// Alias for backward compatibility
export const updatePrintSettings = savePrintSettings;

export const restartServer = async () => {
  const response = await api.post('/admin/restart');
  return response.data;
};

export default api;